var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.08203,
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "rotate(43.954 2.08203 0)",
    fill: "#52447D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "matrix(-0.719897 0.694081 0.694081 0.719897 22.3203 0)",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.b434d33605757c1caa0cf6b40abc38fa.svg";
export { ForwardRef as ReactComponent };